import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { JourneyAssignmentAdminRow } from "./types";

// GET /api/admin/journeys/:id/assignments → { assignments: JourneyAssignmentAdminRow[] }
//
// Sub-bucket 14. Powers the journey builder's Assignments tab. Each row
// carries `partner_name` (joined from partners.company_name) and a
// `progress: { complete, total }` aggregate over journey_task_progress.
// Mutation hooks (useAssignJourney, useUnassignJourney) invalidate this
// key alongside journeys.detail(journeyId).
export function useJourneyAssignments(id: string | undefined) {
  return useQuery<JourneyAssignmentAdminRow[], ApiClientError>({
    queryKey: id
      ? queryKeys.journeys.assignmentsForJourney(id)
      : ["journeys", "detail", "__missing__", "assignments"],
    queryFn: async () => {
      const body = await apiFetch<{ assignments: JourneyAssignmentAdminRow[] }>(
        `/admin/journeys/${id}/assignments`,
      );
      return body.assignments;
    },
    enabled: !!id,
  });
}
